import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import authService from "../../../Services/authService";

export default function SearchSuggestions({ searchQuery, onSelectSuggestion, className = "" }) {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const suggestionsRef = useRef(null);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredSuggestions([]);
      return;
    }

    const loadGlobalSearch = () => {
      const url = new URL(authService.getApiUrl() + "globalsearchdata");

      fetch(url, {
        method: "POST",
        body: JSON.stringify({ search: searchQuery.trim() }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
        },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch search data");
          return res.json();
        })
        .then((result) => {
          const { lab_tests = [], lab_test_packages = [] } = result.data || {};

          const normalizedTests = lab_tests.map((item) => ({
            id: item.id,
            name: item.test_name,
            type: "test",
            slug: item.test_name.toLowerCase().replace(/\s+/g, "-"),
            category_name: item.category_name, // ✅ Needed for URL
          }));

          const normalizedPackages = lab_test_packages.map((item) => ({
            id: item.id,
            name: item.package_name,
            type: "package",
            slug: item.package_name.toLowerCase().replace(/\s+/g, "-"),
            category_name: item.category_name, // ✅ Needed for fallback
          }));


          setFilteredSuggestions([...normalizedTests, ...normalizedPackages]);
        })
        .catch((err) => {
          console.log("Search API Error:", err.message);
        });
    };

    loadGlobalSearch();
  }, [searchQuery]);

  if (filteredSuggestions.length === 0) {
    return null;
  }

  return (
    <div
      ref={suggestionsRef}
      className={`absolute left-0 right-0 top-full mt-1 bg-white border border-[#E0E0E0] rounded-lg shadow-lg z-50 max-h-80 overflow-y-auto ${className}`}
    >
      <div className="py-1">
        {filteredSuggestions.map((suggestion, index) => (
          // <Link
          //   key={`${suggestion.type}-${suggestion.id}`}
          //   to={`/${suggestion.type === "TEST" ? encodeURIComponent(suggestion.category_name.replace(/ /g, '-')) : "full-body-checkups"}/`+encodeURIComponent(suggestion.test_name.replace(/ /g, '-')) + '-' + suggestion.id}
          //   className={`block hover:bg-[#F5F5F7] cursor-pointer ${
          //     index % 2 === 0 ? "bg-white" : "bg-[#F5F5F7]/50"
          //   }`}
          //   onClick={onSelectSuggestion}
          // >
          <Link
            key={`${suggestion.type}-${suggestion.id}`}
            to={`/${suggestion.type === "test"
                ? encodeURIComponent(suggestion.category_name.replace(/ /g, "-"))
                : "package"
              }/${encodeURIComponent(suggestion.slug)}-${suggestion.id}`}
            className={`block hover:bg-[#F5F5F7] cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-[#F5F5F7]/50"
              }`}
            onClick={onSelectSuggestion}
          >

            <div className="flex items-center px-3 py-2.5">
              <div
                className={`text-xs font-medium px-3 py-1 rounded-sm mr-3 ${suggestion.type === "test"
                  ? "bg-[#951C25]/10 text-[#951C25] border border-[#951C25]/20"
                  : "bg-[#4A4A4A]/10 text-[#4A4A4A] border border-[#4A4A4A]/20"
                  }`}
              >
                {suggestion.type}
              </div>
              <div className="flex-1 text-[#4A4A4A] text-sm">{suggestion.name}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
